// @ts-ignore
import React from 'react';
import { FormField } from '@workday/canvas-kit-react';
import { FormFieldErrorProps } from '@workday/upc-common';
import { OldPasswordInput, PasswordTextInputProps } from '../password-input/old-password-input';

interface PasswordFormFieldProps {
    label: string;
    formFieldErrorProps: FormFieldErrorProps;
    passwordTextInputProps: PasswordTextInputProps;
}

export const PasswordFormField = ({ formFieldErrorProps, label, passwordTextInputProps }: PasswordFormFieldProps) => {
    return (
        <FormField label={label} {...formFieldErrorProps} grow={true}>
            <OldPasswordInput {...passwordTextInputProps} />
        </FormField>
    );
};
